import useSessionStorage from './useSessionStorage';

function useNative() {
    const [native, setNative] = useSessionStorage('native');
    const params = new URLSearchParams(window.location.search);
    const newNative = params.get('native');
    if (newNative && newNative !== native) {
        setNative(newNative);
        return newNative;
    }
    return native;
};

export default useNative;